import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import IndustriesPage from "@/pages/IndustriesPage";
import ExportPage from "@/pages/ExportPage";
import SustainabilityPage from "@/pages/SustainabilityPage";
import PartnerPage from "@/pages/PartnerPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import TeamPage from "@/pages/TeamPage";
import CredentialsPage from "@/pages/CredentialsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PayPage from "@/pages/PayPage";
import AdminSetupPage from "@/pages/AdminSetupPage";
import PaymentStatusPage from "@/pages/PaymentStatusPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="industries" element={<IndustriesPage />} />
            <Route path="export" element={<ExportPage />} />
            <Route path="sustainability" element={<SustainabilityPage />} />
            <Route path="partner" element={<PartnerPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/setup" element={<AdminSetupPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="credentials" element={<CredentialsPage />} />
            <Route path="pay/:token" element={<PayPage />} />
            <Route path="payment/status/:token" element={<PaymentStatusPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
